import type { IParentRoute } from '../layout/navbar';

export const platformDefaultsSubRoutes = [
  {
    id: 'reservation-line-mappings',
    title: 'Reservation Line Mappings',
    group: '/platform-defaults',
    url: 'reservation-line-mappings',
  },
  {
    id: 'chart-of-accounts',
    title: 'Chart of Accounts',
    group: '/platform-defaults',
    url: 'accounts',
  },
  {
    id: 'statement-template',
    title: 'Statement Template',
    group: '/platform-defaults',
    url: 'statement-template',
  },
  {
    id: 'fees-and-commissions',
    title: 'Fees & Commissions',
    group: '/platform-defaults',
    url: 'fees-commissions',
  },
] satisfies NonNullable<IParentRoute['subRoutes']>;
